module.exports = function() {
  return new Worker(__webpack_public_path__ + "e60aa21c812c83b05bb1.worker.js");
};